module.exports = __webpack_public_path__ + "static/img/GS.bbc8dec5.svg";